export const routes = {
  ABOUT: "/nosotros",
  ACTIVITIES: "/actividades",
  ACTIVITIESDETAIL: "/actividades/:id",
  ACTIVITIESFORM: "/create-activity",
  AUTHLOGINFORM: "/auth/login",
  AUTHREGISTERFORM: "/auth/register",
  CONTACT: "/contact",
  DONATION: "/donar",
  HOME: "/",
  MEMBERSFORM: "/create-member",
  NEWS: "/novedades",
  NEWSDETAIL: "/novedades/:id",
  NEWSFORM: "/create-news",
  PROJECTFORM: "/create-project",
  TESTIMONIALS: "/testimonials",
  TESTIMONIALSFORM: "/create-testimonials",
  THANKSDONATION: "/gracias",
};

export const privateRoutes = {
  ACTIVITIES: "activities",
  ACTIVITIESCREATE: "activities/create",
  ACTIVITIESEDIT: "activities/edit",
  ACTIVITIESEDITSWITHID: "activities/edit/:id",
  BACKOFFICE: "backoffice/",
  BACKHOME: "home",
  CATEGORIES: "categories",
  CATEGORIESCREATE: "categories/create",
  CATEGORIESEDIT: "categories/edit/",
  CATEGORIESEDITWITHID: "categories/edit/:id",
  CREATEPROJECT: "projects",
  DASHBOARD: "dashboard",
  EDITCATEGORY: "edit-category/:id",
  EDITMEMBERSFORM: "members/edit",
  EDITORGANIZATIONFORM: "organization/edit",
  EDITPROJECT: "projects/:id",
  MEMBERSLIST: "members",
  MEMBERSCREATEFORM: "members/create",
  MEMBERSEDITFORM: "members/edit/",
  MEMBERSEDITFORMWITHID: "members/edit/:id",
  NEWSLIST: "news",
  NEWSEDITFORM: "news/edit/",
  NEWSEDITFORMWITHID: "news/edit/:id",
  NEWSCREATEFORM: "news/create",
  ORGANIZATIONDATA: "organization",
  PROJECTS: "projects",
  SLIDES: "slides",
  SLIDESCREATE: "slides/create",
  SLIDESEDIT: "slides/edit/",
  SLIDESEDITWITHID: "slides/edit/:id",
  TESTIMONIALS: "testimonials",
  TESTIMONIALSFORM: "testimonials/create",
  TESTIMONIALSEDITFORM: "testimonials/edit/:id",
  TESTIMONIALSEDIT: "testimonials/edit/",
  USERS: "users",
  USERSCREATE: "users/create",
  USERSEDIT: "users/edit",
  USERSEDITWITHID: "users/edit/:id",
  USERSFORM: "users",
  USERSEDITFORM: "users/:id",
};
